import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["pages"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as Duration from '@effect/data/Duration';
import { wrapIntoFragment } from '@infl-ts/ui-wrap-into-fragment';
import { hasMode, Modes } from '@infl-ts/util-app-config';
import { useEmbedMode } from '@infl-ts/util-embed-mode-provider';
import { makeApiError } from '@infl-ts/util-make-apollo-decoded';
import { logError } from '@infl-ts/util-query-errors';
import { queryResultToDE } from '@infl-ts/util-react-query';
import * as DE from '@nll/datum/lib/DatumEither';
import { useQuery } from '@tanstack/react-query';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { constFalse, constVoid, flow, identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createAdminConfig } from '../../lib/use-admin-siteconfig';
import { getAdminConfig, getSiteConfig } from './api';

var inPublicMode = function inPublicMode(configs) {
  return pipe(configs.appConfig, O.map(hasMode(Modes.map["public"])), O.getOrElse(constFalse));
};

var goToSignIn = function goToSignIn() {
  return true && window.location.assign("https://".concat(window.location.hostname, "/users/sign_in"));
};

// TODO: Consider separating out adminConfig into its own react-query call
export var fetchConfigs = function fetchConfigs(_ref) {
  var host = _ref.host,
      cookie = _ref.cookie,
      jwt = _ref.jwt;
  return pipe(T.Do, T.apS('siteConfig', getSiteConfig({
    host: host,
    cookie: cookie,
    jwt: jwt
  })), T.apS('adminConfig', getAdminConfig({
    host: host,
    cookie: cookie,
    jwt: jwt
  })), T.map(function (_ref2) {
    var adminConfig = _ref2.adminConfig,
        siteConfig = _ref2.siteConfig;
    return pipe(siteConfig, E.map(function (_ref3) {
      var pages = _ref3.pages,
          rest = _objectWithoutProperties(_ref3, _excluded);

      return {
        pages: pipe(pages, A.map(flow(function (p) {
          return _objectSpread(_objectSpread({}, p), rest);
        }, createAdminConfig(adminConfig)))),
        configs: rest.configs
      };
    }));
  }), TE.orElseFirstW(function (e) {
    return TE.rightIO(function () {
      return logError(e);
    });
  }), TE.getOrElse(function (e) {
    return function () {
      return Promise.reject(e);
    };
  }))();
};
export var FetchSiteConfig = function FetchSiteConfig(_ref4) {
  var children = _ref4.children,
      path = _ref4.path,
      host = _ref4.host,
      jwt = _ref4.jwt;
  var result = useQuery({
    queryKey: ['siteConfigData'],
    meta: {
      jwt: jwt,
      host: host
    },
    queryFn: function queryFn(_ref5) {
      var meta = _ref5.meta;
      return fetchConfigs(meta !== null && meta !== void 0 ? meta : {});
    },
    staleTime: Duration.toMillis(Duration.hours(1)),
    gcTime: Duration.toMillis(Duration.hours(1.5))
  });
  var pathname = pipe(useLocation(), function (_ref6) {
    var pathname = _ref6.pathname;
    return pathname.match(/^\/[^/]*/);
  }, function (match) {
    return match ? match[0] : '/';
  });

  var _useState = useState(function () {
    return identity;
  }),
      customMapper = _useState[0],
      setCustomMapper = _useState[1];

  var _useEmbedMode = useEmbedMode(),
      isEmbedded = _useEmbedMode.isEmbedded;

  useEffect(function () {
    window.inflAdvocate = {
      siteconfigInterceptor: function siteconfigInterceptor(f) {
        setCustomMapper(function () {
          return f;
        });
      }
    };
    document.dispatchEvent(new CustomEvent('inflAdvocate::siteconfigInterceptor::ready'));
    return function () {
      window.inflAdvocate.siteconfigInterceptor = constVoid;
    };
  }, []);
  useEffect(function () {
    window.dispatchEvent(new Event('elevate:trigger-rerender'));
  }, [customMapper]);
  return pipe(queryResultToDE(result), DE.chain(function (_ref7) {
    var pages = _ref7.pages,
        configs = _ref7.configs;
    return pipe(pages, A.findFirst(function (page) {
      return page.href === (path || pathname);
    }), O.matchW(function () {
      if (inPublicMode(configs)) {
        return DE.failure(makeApiError('Not logged in'));
      }

      return DE.failure(makeApiError('Could not find matching path in config'));
    }, DE.success));
  }), DE.map(customMapper), function (result) {
    if (DE.isFailure(result) && result.value.left._tag === 'api' && result.value.left.errors === 'Not logged in') {
      // eslint-disable-next-line no-console
      isEmbedded && host ? console.warn('Access Token Expired/Invalid') : goToSignIn();
      return null;
    }

    return children(result);
  }, wrapIntoFragment);
};